import Navigation from '@/components/Navigation';
import Hero from '@/components/Hero';
import WhyChooseAKIVA from '@/components/WhyChooseAKIVA';
import ServicesOverview from '@/components/ServicesOverview';
import ProductsOverview from '@/components/ProductsOverview';
import Contact from '@/components/Contact';
import Footer from '@/components/Footer';
import SEO from '@/components/SEO';
import StructuredData from '@/components/StructuredData';
import { useEffect } from 'react';
import { useLocation } from '@/lib/router-compat';
import { alignWhenLayoutSettles, scrollToContact } from '@/lib/navigation';
import HomepageSection from '@/components/HomepageSection';

const Index = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location.hash) return;

    if (location.hash === '#contact') {
      // Run after the route transition's scroll reset, without a fixed delay,
      // and keep aligning while the entrance animation, fonts and images move
      // the section. `scrollToContact` reports where the section sits in the
      // document, so the helper knows when the page has actually stopped moving.
      return alignWhenLayoutSettles(options => scrollToContact(options));
    }

    const id = location.hash.slice(1);
    return alignWhenLayoutSettles((options) => {
      const el = document.getElementById(id);
      if (!el) return undefined;
      // Only write when the target is clearly off its resting place. A
      // sub-pixel residual is rounding, and a redundant write fires scroll
      // events and can fight the router's own reset.
      if (Math.abs(el.getBoundingClientRect().top - 80) > 1) {
        window.scrollTo({
          top: Math.round(el.getBoundingClientRect().top + window.scrollY - 80),
          behavior: options.instant ? 'instant' : 'smooth',
        });
      }
      return el.getBoundingClientRect().top + window.scrollY;
    });
  }, [location]);

  return (
    <div className="min-h-dvh bg-background">
      <SEO 
        title="AKIVA | AI Engineering & Strategy Consulting"
        description="AKIVA delivers enterprise AI solutions including machine learning, multi-agent systems, MLOps, and strategy consulting for government and commercial clients."
        canonicalUrl="/"
      />
      <StructuredData type="organization" />
      <StructuredData type="website" />
      <StructuredData type="professional" />
      <Navigation />
      <Hero />
      
      <HomepageSection><WhyChooseAKIVA /></HomepageSection>
      
      <HomepageSection><ServicesOverview /></HomepageSection>
      
      <HomepageSection><ProductsOverview /></HomepageSection>
      
      <HomepageSection><Contact /></HomepageSection>
      
      <Footer />
    </div>
  );
};

export default Index;
